<app-header [text]='!!category ? category.text : "default"' (customClick)='clickHeader()'></app-header>

<div id="readspeaker_button_1" class="rs_skip rsbtn rs_preserve" *ngIf="env.readspeaker.enabled">
  <a rel="nofollow" class="rsbtn_play" accesskey="L" i18n-title="@@readSpeakerDescription" title="Listen to this page using ReadSpeaker webReader" [attr.href]="getReadSpeakerURL('question')">
      <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span i18n="@@readSpeakerListen">Listen</span></span></span>
      <span class="rsbtn_right rsimg rsplay rspart"></span>
  </a>
</div>

<div class="row">
  <div class="col-12 col-xl-6">
    <app-media *ngIf="!!scenario" [resource]='scenario.resource' replay=true></app-media>
  </div>
  <div class="content col-12 col-xl-6" id="question">
    <app-question
    *ngIf="!!question"
    [(question)]="question"
    [(error)]="errorMessage"
    (answer)="processAnswer($event)"
    [initialAnswer]="currentAnswer"
    ></app-question>
  </div>
</div>

<div class="footer">
  <div class="progress">
    <div
      class="progress-bar"
      role="progressbar"
      [style.width]="progress+'%'" 
      [attr.aria-valuenow]="progress"
      aria-valuemin="0"
      aria-valuemax="100"
    ><span *ngIf="progress==15 || progress>15" i18n="@@progressBarLabel">{{progress}}% Complete!</span></div>
    <span class="progress-bar-label" *ngIf="progress < 15" i18n="@@progressBarLabel">{{progress}}% Complete!</span>
  </div>
  <app-navigate-button
    [buttons] = "buttons"
    (buttonsEvent)='onButtonsEvent($event)'
    ></app-navigate-button>
</div>


<button (click)="resultsModal.show()" class='hidden' id='resultsModal'></button>

<div mdbModal #resultsModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myresultsModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="resultsModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel" i18n="@@navigation-go-to-results">Go to results</h4>
      </div>
      <div class="modal-body" i18n="">
        If you go to results you won't be able to go back
      </div>
      <div class="modal-footer">
        <button type="button" mdbBtn class="button continue" (click)="goToResults()" mdbWavesEffect i18n="@@navigation-go-to-results">Go to results</button>
        <button type="button" mdbBtn class="button cancel" aria-label="Close" (click)="resultsModal.hide()" mdbWavesEffect i18n="">Back to task</button>
      </div>
    </div>
  </div>
</div>